module.exports = __webpack_public_path__ + "static/media/heart-gray.ffb14ceb.svg";